<template>
  <ul class="e-myclass">
    <li v-for="(lesson, lessonIndex) in lessones" :key="lessonIndex">
      <div class="info">
        <div class="info-img" :style="{ backgroundImage: `url(${lesson.thumb})` }"></div>
        <div class="info-content">
          <p class="title text-overflow">{{lesson.title}}</p>
          <div class="progress">
            <p>已完成{{ toFix(lesson.schedule * 100) }}%</p>
            <div class="chart" :style="{ backgroundImage: `linear-gradient(to right, #FF6565 0%, #FF6565 ${toFix(lesson.schedule * 100)}%, #EBEBEB ${toFix(lesson.schedule * 100)}%, #EBEBEB 100%)` }"></div>
          </div>
          <div class="btns">
            <router-link class="enter" v-if="isOpen(lesson.classstar)" :to="`/m/study/${lesson.maitemid}`">进入课程</router-link>
          </div>
        </div>
      </div>
      <div class="chapters">
        <ul>
          <li v-for="(chapter, chapterIndex) in lesson.chapter" :key="chapterIndex" @click="$router.push(`/m/study/${lesson.maitemid}/${chapterIndex}/0`)">
            <p class="chapter-title text-overflow2">{{chapterIndex + 1}}.{{chapter.title}}</p>
            <div class="chapter-progress">
              <chapterProgress
              :progress="chapter.browse / chapter.totallist * 100"
              :done="chapter.exstatus"
              :radius="22"
              :width="50"
              :height="50"
              />
            </div>
            <p class="chapter-grade" v-if="chapter.exstatus">测试完成</p>
            <p class="chapter-schedule" v-if="!chapter.exstatus">已学习{{chapter.browse}}/{{chapter.totallist}}课</p>
          </li>
        </ul>
      </div>
    </li>
    <li class="no-info" v-if="!loading && !lessones">
      当前没有正在学习的课程～
    </li>
  </ul>
</template>

<script>
import api from '@/api/index'
import chapterProgress from '@/components/myroom/progress'

export default {
  data () {
    return {
      lessones: null,
      loading: true
    }
  },
  components: {
    chapterProgress
  },
  filters: {
    getStudyStr (val) {
      if (val) {
        if (val === 100) {
          return '再次学习'
        } else {
          // return '继续学习'
          return '进入教室'
        }
      } else {
        return '进入教室'
      }
    }
  },
  computed: {
  },
  methods: {
    toFix (val) {
      let result
      try{
        result = val.toFixed(1)
      } catch (e) {
        return val
      }
      return result
    },
    getStrokeDashoffset (schedule) {
      return ((100 - schedule * 100) / 100) * Math.PI * (66 * 2)
    },
    isOpen (classstar) {
      return new Date().getTime() > new Date(classstar * 1000).getTime()
    },
    async getMyLesson () {
      this.loading = true
      let res = await api.getRoomInfo()
      this.lessones = res.data
      this.loading = false
    }
  },
  mounted() {
    this.getMyLesson()
  }
}
</script>

<style lang="scss" scoped>
.e-myclass {
  padding: 10px;
  & > li {
    margin-bottom: 30px;
    .info{
      position: relative;
      .info-img{
        width: 120px;
        height: 100px;
        position: absolute;
        background-size: cover;
        top: 0;
        left: 5px;
        border-radius: 8px;
      }
      .info-content{
        margin-left: 137px;
        height: 100px;
        margin-bottom: 20px;
        .title{
          font-size: 15px;
          line-height: 20px;
          margin-bottom: 10px;
          color: #000000;
        }
        .progress{
          p{
            line-height: 16px;
            color: #FF6565;
            font-size: 12px;
            margin-bottom: 7px;
          }
          .chart{
            width: 100%;
            height: 2px;
          }
        }
        .btns{
          margin-top: 20px;
          a{
            display: block;
            width: 70px;
            height: 23px;
            border: 1px solid #FF6565;
            color: #FF6565;
            border-radius: 19px;
            font-size: 12px;
            line-height: 23px;
            text-align: center;
            text-decoration: none;
          }
        }
      }
    }
    .chapters{
      white-space: nowrap;
      overflow: auto;
      -webkit-user-select: none;
      display: block;
      height: 51px;
      overflow-y: hidden;
      padding: 0;
      position: relative;
      -webkit-overflow-scrolling: touch;
      overflow-x: scroll;
      height: 142px;
      padding-left: 10px;
      & > ul{
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        font-size: 0;
        li{
          display: inline-block;
          width: 116px;
          height: 140px;
          margin-right: 10px;
          text-align: center;
          font-size: 12px;
          border: 1px solid #EAEAEA;
          .chapter-title{
            padding-top: 12px;
            line-height: 18px;
            font-size: 12px;
            padding: 12px 9px 8px 9px;
            height: 36px;
            max-width: 100%;
            white-space: pre-line;
          }
          .chapter-grade, .chapter-schedule{
            margin-top: 8px;
            line-height: 16px;
            font-size: 12px;
            color: #FF6565;
          }
        }
      }
    }
  }
  .no-info{
    color: #5C5F63;
    margin-top: 80%;
    text-align: center;
  }
}
</style>
